import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const DEFAULT_CHAPTERS = [
    {
        n: "01",
        title: "Signal Lost",
        body: "We make clothes for the moments your phone cannot reach. Heavyweight fabric, zero notifications. Every stitch is a boundary between you and the noise.",
        span: "md:col-span-7",
    },
    {
        n: "02",
        title: "Analog Luxury",
        body: "480gsm loopback fleece. Garment-dyed in void black. Cut boxy, finished by hand. Richness you feel in the weight — not in a logo farm.",
        span: "md:col-span-5",
    },
    {
        n: "03",
        title: "The New Status",
        body: "Being unreachable is the ultimate flex. The Wi-Fi mark on your chest is a promise: where you are, the feed is not.",
        span: "md:col-span-6 md:col-start-4",
    },
];

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-6 md:col-start-4"];

export const Manifesto = ({ chapters = DEFAULT_CHAPTERS }) => (
    <section id="manifesto" className="relative px-6 sm:px-12 py-32 sm:py-44" data-testid="manifesto-section">
        <motion.p
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE }}
            className="text-[11px] tracking-[0.4em] uppercase text-signal mb-16 sm:mb-24"
        >
            The Manifesto
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-24 md:gap-y-32">
            {chapters.map((c, i) => (
                <motion.div
                    key={c.n}
                    initial={{ y: 70, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 1, ease: EASE, delay: i * 0.08 }}
                    className={`relative ${c.span}`}
                    data-testid={`manifesto-chapter-${c.n}`}
                >
                    <span className="absolute -top-14 sm:-top-24 -left-2 font-display font-bold text-[7rem] sm:text-[11rem] leading-none text-stroke select-none pointer-events-none">
                        {c.n}
                    </span>
                    <div className="relative pt-10 sm:pt-16 border-t border-zinc-800">
                        <h3 className="font-display font-semibold uppercase tracking-tight text-2xl sm:text-4xl mb-5 group cursor-default">
                            <span className="inline-block w-2 h-2 rounded-full bg-signal mr-4 align-middle transition-transform duration-300 group-hover:scale-150" />
                            {c.title}
                        </h3>
                        <p className="text-base sm:text-lg leading-relaxed text-zinc-400 max-w-md">{c.body}</p>
                    </div>
                </motion.div>
            ))}
        </div>
    </section>
);
